export const environment = {
  production: true,
  api: 'https://v2fieldprodlb.analytics.brussels', 
  mapbox: {
    accessToken: 'pk.eyJ1IjoiYmxhemVjbGFuIiwiYSI6ImNqOWZxM3h1MzAzMW8zMnJxd3g0NzZ5a20ifQ.5IdwsnKmxrQftgM-3-P5IA#11.0/50.839325/4.347952/0'
  },
  getPosDetailsByQuartierApi: 'https://7rx5mcoa32.execute-api.eu-central-1.amazonaws.com/dev',
  otaUrl: 'prod',
  Pull_Access_Key: "55dc66ea-b7a6-5478-9a9d-b3ce97fc5310"
  //Pull_Access_Key: "8e7282bc-84c6-5ca1-82e2-bca693170c0b"
};



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/environments/environment.ts